import { IdentificationClient } from '@frontend/identification/api';
import { Identification, IdentificationType } from '@frontend/identification/types';
import { useModals } from '@frontend/modal';
import { useEffect, useState } from 'react';

import { BasicAuthCardProps } from './basic-auth-card.component';

export const useBasicAuthCard = (props: BasicAuthCardProps) => {
    const [basicAuth, setBasicAuth] = useState<Identification | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { openModal, closeModal } = useModals();
    const updateBasicAuthId = 'update-basic-auth';
    const createBasicAuthId = 'create-basic-auth';
    const deleteBasicAuthId = 'delete-basic-auth';

    useEffect(() => {
        IdentificationClient.fetchIdentifications({ entity_id: props.entity_id, type: IdentificationType.BASIC_AUTH }).then((response) => {
            if (response.results.length > 0) {
                setBasicAuth(response.results[0]);
            } else {
                setBasicAuth(null);
            }
            setIsLoading(false);
        });
    }, [props.entity_id]);

    return {
        basicAuth,
        isLoading,
        openModal,
        closeModal,
        updateBasicAuthId,
        setBasicAuth,
        createBasicAuthId,
        deleteBasicAuthId
    };
};
